module.exports = "https://images.shiksha.ws/saassets/media/zeroEmoji.572f40ab.png";